import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-home-library',
  templateUrl: './home-video-library.component.html',
  styleUrl: './home-video-library.component.css',
  standalone: false,
})
export class HomeVideoLibraryComponent implements OnChanges, OnInit {

  constructor(private readonly route: Router) { } // Injecting Router service to navigate between routes
  @Input() allVideos: any[] = []; // Input property to receive all videos from parent component
  @Input() isHomePage: string; // Flag to check if it's the home page
  @Output() mediaReady = new EventEmitter<void>();
  selectedHomeVideo: any; // Add the selectedHomeVideo property
  private readyVideoIndexes = new Set<number>();
  private hasEmittedMediaReady = false;

  ngOnInit(): void {
    this.fetchHomeVideos(); // Call fetchHomeVideos on initialization
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allVideos']) {
      this.readyVideoIndexes.clear();
      this.hasEmittedMediaReady = false;

      if (!this.allVideos?.length) {
        this.emitMediaReady();
      }
    }
  }

  fetchHomeVideos(): void {
    // Mock implementation for fetching home videos
    console.log('Fetching home videos...');
  }

  selectHomeVideo(video: any): void {
    this.selectedHomeVideo = video; // Set the selected video
  }

  navigateToAllVideoPage() {
    this.route.navigate(['/video-library']);
  }

  onVideoCardReady(index: number): void {
    this.readyVideoIndexes.add(index);

    if (this.readyVideoIndexes.size >= this.allVideos.length) {
      this.emitMediaReady();
    }
  }

  private emitMediaReady(): void {
    if (this.hasEmittedMediaReady) {
      return;
    }

    this.hasEmittedMediaReady = true;
    this.mediaReady.emit();
  }
}
